import React from "react";

const testimonialsLeft = [
  "The team was absolutely fantastic and helped me heal quickly!",
  "Highly professional and deeply caring staff — amazing experience.",
  "My surgery and recovery were so smooth — thank you to all!",
  "The nurses went above and beyond every single day.",
];

const testimonialsRight = [
  "Incredible hospital — I felt safe every step of the way.",
  "Doctors explained everything so clearly — I trusted them fully.",
  "The support during my stay was outstanding and very personal.",
  "Thank you for giving me my health and hope back.",
];

const containerStyle = {
  width: "100%",
  height: "400px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  overflow: "hidden",
  background: "#e2e8ccff",
  padding: "0 20px",
  boxSizing: "border-box",
};

const columnStyle = (direction) => ({
  flex: 1,
  height: "100%",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
});

const trackStyle = (direction) => ({
  display: "flex",
  flexDirection: "column",
  animation: `${
    direction === "up" ? "scrollUp" : "scrollDown"
  } 25s linear infinite`,
});

const cardStyle = {
  width: "80%",
  background: "#ffffff",
  padding: "16px",
  margin: "12px auto",
  borderRadius: "12px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  fontSize: "15px",
  color: "#444",
  position: "relative",
  minHeight: "100px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const quoteStyle = {
  fontSize: "28px",
  color: "#c8d893ff",
  marginBottom: "8px",
};

const centerTextStyle = {
  flex: "0 0 200px",
  textAlign: "center",
  fontWeight: "bold",
  fontSize: "22px",
  color: "#004080",
  padding: "0 20px",
};

const styleSheet = `
@keyframes scrollUp {
  0% { transform: translateY(0%); }
  100% { transform: translateY(-50%); }
}

@keyframes scrollDown {
  0% { transform: translateY(-50%); }
  100% { transform: translateY(0%); }
}
`;

const DualTestimonials = () => {
  const doubleLeft = [...testimonialsLeft, ...testimonialsLeft];
  const doubleRight = [...testimonialsRight, ...testimonialsRight];

  return (
    <div style={containerStyle}>
      <style>{styleSheet}</style>
      <div>
        <div style={centerTextStyle}>What Our Patients Say</div>
        <p style={{ textAlign: "center", marginTop: "8px", color: "#555" }}>
          Hear from our patients about their experiences and care with us.
        </p>
      </div>

      <div style={{ display: "flex" }}>
        <div style={columnStyle("up")}>
          <div style={trackStyle("up")}>
            {doubleLeft.map((text, i) => (
              <div key={i} style={cardStyle}>
                <div style={quoteStyle}>❝</div>
                <div>{text}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={columnStyle("down")}>
          <div style={trackStyle("down")}>
            {doubleRight.map((text, i) => (
              <div key={i} style={cardStyle}>
                <div style={quoteStyle}>❝</div>
                <div>{text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualTestimonials;
